var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_661_2167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33329 9.58327V12.9166C3.33329 13.6083 3.89163 14.1666 4.58329 14.1666C5.27496 14.1666 5.83329 13.6083 5.83329 12.9166V9.58327C5.83329 8.8916 5.27496 8.33327 4.58329 8.33327C3.89163 8.33327 3.33329 8.8916 3.33329 9.58327ZM8.33329 9.58327V12.9166C8.33329 13.6083 8.89163 14.1666 9.58329 14.1666C10.275 14.1666 10.8333 13.6083 10.8333 12.9166V9.58327C10.8333 8.8916 10.275 8.33327 9.58329 8.33327C8.89163 8.33327 8.33329 8.8916 8.33329 9.58327ZM2.91663 18.3333H16.25C16.9416 18.3333 17.5 17.7749 17.5 17.0833C17.5 16.3916 16.9416 15.8333 16.25 15.8333H2.91663C2.22496 15.8333 1.66663 16.3916 1.66663 17.0833C1.66663 17.7749 2.22496 18.3333 2.91663 18.3333ZM13.3333 9.58327V12.9166C13.3333 13.6083 13.8916 14.1666 14.5833 14.1666C15.275 14.1666 15.8333 13.6083 15.8333 12.9166V9.58327C15.8333 8.8916 15.275 8.33327 14.5833 8.33327C13.8916 8.33327 13.3333 8.8916 13.3333 9.58327ZM8.80829 1.2416L2.22496 4.70827C1.88329 4.88327 1.66663 5.2416 1.66663 5.62494C1.66663 6.19993 2.13329 6.6666 2.70829 6.6666H16.4666C17.0333 6.6666 17.5 6.19993 17.5 5.62494C17.5 5.2416 17.2833 4.88327 16.9416 4.70827L10.3583 1.2416C9.87496 0.983268 9.29163 0.983268 8.80829 1.2416Z",
    fill: "#001929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_661_2167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAccountIcon);
export default __webpack_public_path__ + "static/media/BankAccountIcon.5f2bdc49c6566612946c4e84ceee5af9.svg";
export { ForwardRef as ReactComponent };